import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2;

import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
var InputSuffixElement = styled(function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/cloneElement(children, props);
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasError', 'isDisabled'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var hasError = _ref2.hasError,
      isDisabled = _ref2.isDisabled,
      isFocused = _ref2.isFocused,
      theme = _ref2.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      /* This is needed for IE */\n      flex-shrink: 0;\n\n      /* No other way to apply styling */\n      svg {\n        fill: ", ";\n        fill: ", ";\n        fill: ", ";\n        fill: ", ";\n        padding-right: ", ";\n      }\n\n      &:hover,\n      &:focus {\n        /* No other way to apply styling */\n        svg {\n          fill: ", ";\n        }\n      }\n    "])), theme.color.gray['600'].value, isFocused && theme.color.primary['500'].value, hasError && theme.color.system.negative[500].value, isDisabled && theme.color.text.light.disabled.value, theme.size.spacing.small.value, !isDisabled && theme.color.primary['500'].value);
});
InputSuffixElement.propTypes = {
  /** If true, input is in error state */
  hasError: PropTypes.bool,

  /** If true, disables state appearances changes */
  isDisabled: PropTypes.bool
};
InputSuffixElement.defaultProps = {
  hasError: false,
  isDisabled: false
};
export { InputSuffixElement };